module.exports = __webpack_public_path__ + "static/media/menu-icon-special-locked.9b0fd5da.png";